import { Cohort } from '~/shared/constants/commonConstants'

const ANATOMY_PROGRESS_SECTIONS: Record<string, string[]> = {
  'onboarding.progressBar.profile': [
    'age-1',
    'gender-1',
    'goals-anatomy-1',
    'anatomy-curiosity-1',
    'foot-biomechanics-1',
    'digestive-system-1',
    'brain-nervous-system-1',
  ],
  'onboarding.progressBar.yourLevel': [
    'learn-anatomy-1',
    'anatomy-satisfied-1',
    'distractions-anatomy-1',
    'anatomy-feelings-1',
    'pelvic-floor-1',
    'kidneys-filtration-1',
    'brain-pain-1',
    'strongest-muscle-1',
    'smallest-bone-1',
    'organ-regenerates-1',
  ],
  'onboarding.progressBar.preferences': [
    'motivation-anatomy-1',
    'kind-of-learning-anatomy-1',
    'statement-anatomy-1',
    'recommendation-anatomy-1',
    'specific-reason-anatomy-1',
    'topics-anatomy-1',
    'daily-goal-anatomy-1',
    'prepare-plan-1',
    'email-1',
  ],
}

export const PROGRESS_SECTIONS_BY_COHORT: Partial<
  Record<Cohort, Record<string, string[]>>
> = {
  [Cohort.ANATOMY]: ANATOMY_PROGRESS_SECTIONS,
  [Cohort.ANATOMY_EXT]: ANATOMY_PROGRESS_SECTIONS,
  [Cohort.ANATOMY_ALT]: ANATOMY_PROGRESS_SECTIONS,
}
